<script lang="ts" setup>
const config = useRuntimeConfig();
const versionString = computed(() => {
  return `${config.public.CKSETUP_VERSION}@${config.public.BUILD_TIMESTAMP}`;
});
</script>

<template>
  <footer class="flex w-full">
    <div class="flex justify-end w-full bg-ngray-6 text-xs text-ngray-5 px-6 p-3">{{ versionString }}</div>
  </footer>
</template>
